import React from 'react'
import {IconProps} from 'types/IconProps'

const CounterClockWiseIcon = (props: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={props.width ?? '16'}
      height={props.height ?? '16'}
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_12516_7846)'>
        <path
          d='M14 8C14.0002 9.57743 13.3791 11.0915 12.2712 12.2144C11.1634 13.3373 9.65792 13.9788 8.08063 14H8.00001C6.46766 14.0038 4.99268 13.4174 3.88126 12.3625C3.83353 12.3174 3.79516 12.2633 3.76834 12.2033C3.74152 12.1433 3.72678 12.0786 3.72495 12.013C3.72312 11.9473 3.73425 11.8819 3.75769 11.8206C3.78113 11.7592 3.81643 11.703 3.86157 11.6553C3.90671 11.6076 3.96081 11.5692 4.02078 11.5424C4.08075 11.5156 4.14542 11.5008 4.21109 11.499C4.27676 11.4972 4.34214 11.5083 4.40351 11.5317C4.46488 11.5552 4.52103 11.5905 4.56876 11.6356C5.28363 12.3098 6.18131 12.7584 7.14965 12.9254C8.11799 13.0923 9.11407 12.9703 10.0134 12.5744C10.9128 12.1786 11.6756 11.5265 12.2066 10.6997C12.7375 9.87282 13.013 8.90786 12.9987 7.92534C12.9844 6.94281 12.6809 5.98627 12.1262 5.17522C11.5714 4.36418 10.79 3.73457 9.87945 3.36506C8.96894 2.99555 7.96974 2.90252 7.00666 3.09759C6.04359 3.29266 5.15934 3.76718 4.46438 4.46187C4.45928 4.46739 4.45385 4.47261 4.44813 4.4775L3.78938 5.08062L4.85188 6.14312C4.92286 6.21277 4.97145 6.30199 4.99146 6.39939C5.01147 6.4968 5.00198 6.59795 4.96421 6.68993C4.92643 6.78192 4.86209 6.86055 4.77941 6.91578C4.69672 6.97101 4.59944 7.00033 4.50001 7H1.50001C1.3674 7 1.24022 6.94732 1.14646 6.85355C1.05269 6.75978 1.00001 6.63261 1.00001 6.5V3.5C0.999433 3.40084 1.02836 3.30374 1.0831 3.22106C1.13784 3.13838 1.21594 3.07384 1.30745 3.03566C1.39897 2.99747 1.49977 2.98736 1.59705 3.0066C1.69432 3.02585 1.78368 3.07359 1.85376 3.14375L3.08188 4.375L3.76563 3.75C4.60562 2.91327 5.67468 2.34416 6.83784 2.11452C8.001 1.88487 9.20613 2.00498 10.3011 2.45968C11.3961 2.91438 12.3318 3.68329 12.9901 4.66934C13.6484 5.65539 13.9998 6.81438 14 8Z'
          fill='#F45045'
        />
      </g>
      <defs>
        <clipPath id='clip0_12516_7846'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CounterClockWiseIcon
